(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-headline"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initAnimatedHeadline(section) {
    var sectionId = section.dataset.sectionId;
    var rotator = section.querySelector('.ahl__rotator');
    if (!rotator) return;

    var words = Array.from(rotator.querySelectorAll('.ahl__word'));
    if (words.length === 0) return;

    /* Respect prefers-reduced-motion */
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      /* Show only the first word statically */
      rotator.setAttribute('data-ahl-ready', 'true');
      words.forEach(function (w, i) {
        if (i === 0) {
          w.classList.add('ahl__word--active');
          w.classList.remove('ahl__word--exit');
          w.style.position = 'static';
          w.style.opacity = '1';
          w.style.transform = 'none';
        } else {
          w.style.display = 'none';
        }
      });
      /* Size the rotator to the first word */
      sizeRotator(rotator, [words[0]]);
      return;
    }

    /* ── Measure widest word to reserve space ── */
    /* Temporarily make all words static + visible for measurement */
    words.forEach(function (w) {
      w.style.position = 'static';
      w.style.opacity = '1';
      w.style.transform = 'none';
      w.style.display = 'block';
    });

    sizeRotator(rotator, words);

    /* Restore absolute positioning */
    words.forEach(function (w, i) {
      w.style.position = '';
      w.style.display = '';
      if (i === 0) {
        w.style.opacity = '';
        w.style.transform = '';
        w.classList.add('ahl__word--active');
      } else {
        w.style.opacity = '0';
        w.style.transform = 'translateY(0.4em)';
      }
    });

    rotator.setAttribute('data-ahl-ready', 'true');

    if (words.length < 2) return;

    var speedMs = parseInt(rotator.dataset.speed, 10) || 2000;
    var current = 0;
    var transitioning = false;

    /* Duration must match CSS transition duration */
    var transDuration = 400;

    function next() {
      if (transitioning) return;
      transitioning = true;

      var currentWord = words[current];
      var nextIndex = (current + 1) % words.length;
      var nextWord = words[nextIndex];

      /* Exit current */
      currentWord.classList.add('ahl__word--exit');
      currentWord.classList.remove('ahl__word--active');

      /* Enter next after transition */
      setTimeout(function () {
        nextWord.classList.add('ahl__word--active');

        /* Update aria-label for screen reader snapshot */
        rotator.setAttribute('aria-label', nextWord.textContent.trim());

        /* Clean up exit class */
        setTimeout(function () {
          currentWord.classList.remove('ahl__word--exit');
          current = nextIndex;
          transitioning = false;
        }, transDuration);
      }, transDuration);
    }

    var timer = setInterval(next, speedMs);

    /* Pause on hover / focus for accessibility */
    section.addEventListener('mouseenter', function () { clearInterval(timer); });
    section.addEventListener('mouseleave', function () { timer = setInterval(next, speedMs); });
    section.addEventListener('focusin', function () { clearInterval(timer); });
    section.addEventListener('focusout', function () { timer = setInterval(next, speedMs); });
  }

  function sizeRotator(rotator, words) {
    var maxWidth = 0;
    var maxHeight = 0;
    words.forEach(function (w) {
      var rect = w.getBoundingClientRect();
      if (rect.width > maxWidth) maxWidth = rect.width;
      if (rect.height > maxHeight) maxHeight = rect.height;
    });
    if (maxWidth > 0) {
      rotator.style.width = maxWidth + 'px';
    }
    if (maxHeight > 0) {
      rotator.style.height = maxHeight + 'px';
    }
  }

  function boot() {
    document.querySelectorAll('[id^="animated-headline-"]').forEach(function (section) {
      initAnimatedHeadline(section);
    });
  }

  /* Shopify theme editor re-init on section load/select */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[id^="animated-headline-"]');
    if (section) initAnimatedHeadline(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefit-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * When the marquee layout is active, pause the CSS scroll animation
   * while the bar is scrolled off-screen (saves battery/CPU on long
   * sessions). Reduced-motion handling itself lives entirely in CSS
   * (@media (prefers-reduced-motion: reduce)) so the bar is still static
   * for those visitors even if this script never runs.
   * @param {HTMLElement} root — the section root element
   */
  function initBenefitBar(root) {
    if (root.dataset.benefitBarReady === 'true') return;
    root.dataset.benefitBarReady = 'true';

    var marquee = root.querySelector('.benefit-bar__marquee');
    if (!marquee || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          marquee.classList.toggle('benefit-bar__marquee--paused', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    io.observe(marquee);

    document.addEventListener('shopify:section:unload', function onUnload(e) {
      if (e.detail && e.detail.sectionId === root.dataset.sectionId) {
        io.disconnect();
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    });
  }

  function boot() {
    document.querySelectorAll('.benefit-bar[data-section-id]').forEach(initBenefitBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: (re)initialise when this section is loaded/re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.benefit-bar[data-section-id]');
    if (root) initBenefitBar(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * Minimal ₹ formatter — prices are stored on each tile as integer paise/cents
   * (Shopify's smallest-currency-unit convention), so we divide by 100 and group
   * with Indian digit spacing (1,00,000 style) via toLocaleString.
   */
  function formatMoney(cents) {
    var amount = Math.round((cents || 0) / 100);
    var grouped = Math.abs(amount).toLocaleString('en-IN');
    return (amount < 0 ? '-' : '') + '₹' + grouped;
  }

  async function postJSON(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) throw data;
    return data;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function initBundleBuilder(root) {
    if (!root || root.dataset.bbReady === 'true') return;
    root.dataset.bbReady = 'true';

    var stackSize = parseInt(root.dataset.stackSize, 10) || 3;
    // Fixed bundle price in the smallest unit (merchant enters rupees)
    var bundlePrice = (parseInt(root.dataset.bundlePrice, 10) || 0) * 100;
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-bb-tile]'));
    var summary = root.querySelector('[data-bb-summary]');
    var addButton = root.querySelector('[data-bb-add]');
    var slotEls = Array.prototype.slice.call(root.querySelectorAll('[data-bb-slot]'));
    var progressEl = root.querySelector('[data-bb-progress]');
    var mrpEl = root.querySelector('[data-bb-mrp]');
    var totalEl = root.querySelector('[data-bb-total]');
    var saveEl = root.querySelector('[data-bb-save]');
    var offerEl = root.querySelector('.bundle-builder__offer');
    var errorEl = root.querySelector('[data-bb-error]');
    var spinner = addButton ? addButton.querySelector('[data-bb-spinner]') : null;
    var addLabel = addButton ? addButton.querySelector('[data-bb-add-label]') : null;

    // Shopper-facing copy — read once from the section's data attributes
    // (themselves rendered from section settings), falling back to the
    // original literals if a setting is ever missing.
    var S = {
      add: root.dataset.strAdd || 'Add to stack',
      added: root.dataset.strAdded || 'Added ✓',
      pick: root.dataset.strPick || 'Pick {count} pieces to build your stack',
      more: root.dataset.strMore || 'Add {remaining} more to complete your stack',
      complete: root.dataset.strComplete || 'Stack complete',
      completeSave: root.dataset.strCompleteSave || 'Stack complete — you save {amount}',
      saveChip: root.dataset.strSaveChip || 'SAVE {amount}',
      full: root.dataset.strFull || 'Your stack is full — remove a piece to swap this one in.',
      error: root.dataset.strError || 'Something went wrong adding your stack — please try again.',
      remove: root.dataset.strRemove || 'Remove {title} from stack',
    };

    // Ordered picks — {id, price, title, img} — drives the slot tray.
    var picks = [];

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function setTileState(tile, on) {
      tile.classList.toggle('is-selected', on);
      tile.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = tile.querySelector('[data-bb-tile-label]');
      if (label) label.textContent = on ? S.added : S.add;
    }

    function findTile(id) {
      for (var i = 0; i < tiles.length; i++) {
        if (tiles[i].dataset.variantId === id) return tiles[i];
      }
      return null;
    }

    function removePick(id) {
      picks = picks.filter(function (p) { return p.id !== id; });
      var tile = findTile(id);
      if (tile) setTileState(tile, false);
      showError('');
      render();
    }

    function renderSlots() {
      slotEls.forEach(function (slot, i) {
        var pick = picks[i];
        slot.classList.toggle('is-filled', !!pick);
        if (!pick) {
          slot.innerHTML = '';
          return;
        }
        // Rebuild only when the slot shows a different pick
        if (slot.dataset.pickId === pick.id) return;
        slot.dataset.pickId = pick.id;
        slot.innerHTML = '';
        if (pick.img) {
          var img = document.createElement('img');
          img.src = pick.img;
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          slot.appendChild(img);
        }
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'bundle-builder__slot-remove';
        remove.setAttribute('aria-label', S.remove.replace('{title}', pick.title || 'piece'));
        remove.innerHTML = '&times;';
        remove.addEventListener('click', function (e) {
          e.stopPropagation();
          removePick(pick.id);
        });
        slot.appendChild(remove);
      });
      // Clear stale pick markers on emptied slots
      slotEls.forEach(function (slot, i) {
        if (!picks[i]) delete slot.dataset.pickId;
      });
    }

    function render() {
      renderSlots();

      var count = picks.length;
      var complete = count === stackSize;
      var remaining = stackSize - count;

      // Two pricing models, unified (how elra.in does it):
      //  A) Shadow products — picks are duplicate "-byos" products already priced
      //     at the bundle share, carrying the real price as compare-at. Savings
      //     come from compare-at; no discount engine involved.
      //  B) Real products + automatic discount — the fixed bundle_price setting
      //     stands in for what checkout will charge.
      var sumPrice = picks.reduce(function (s, p) { return s + p.price; }, 0);
      var sumMrp = picks.reduce(function (s, p) { return s + (p.compare > p.price ? p.compare : p.price); }, 0);
      var paid = bundlePrice > 0 && bundlePrice < sumPrice ? bundlePrice : sumPrice;
      var showStrike = complete && sumMrp > paid;
      var saving = sumMrp - paid;

      // Progress copy — the Elra guidance line
      if (progressEl) {
        if (count === 0) {
          progressEl.textContent = S.pick.replace('{count}', stackSize);
        } else if (!complete) {
          progressEl.textContent = S.more.replace('{remaining}', remaining);
        } else if (showStrike) {
          progressEl.textContent = S.completeSave.replace('{amount}', formatMoney(saving));
        } else {
          progressEl.textContent = S.complete;
        }
      }

      // Pricing — struck MRP + what the shopper actually pays, once complete
      if (mrpEl) {
        mrpEl.hidden = !showStrike;
        if (showStrike) mrpEl.textContent = formatMoney(sumMrp);
      }
      if (totalEl) totalEl.textContent = formatMoney(complete ? paid : sumPrice);
      if (saveEl) {
        saveEl.hidden = !showStrike;
        if (showStrike) saveEl.textContent = S.saveChip.replace('{amount}', formatMoney(saving));
      }
      // Edge case: a complete stack summing BELOW the advertised bundle price
      // (e.g. placeholder catalogue) — hide the offer chip so it can't contradict
      // the total. With shadow pricing (sum == bundle) the chip stays, correctly.
      if (offerEl && bundlePrice > 0) {
        offerEl.hidden = complete && sumPrice < bundlePrice;
      }

      // The bundle CTA unlocks only at exactly N — this is a fixed-size offer
      if (addButton && !addButton.classList.contains('is-loading')) {
        addButton.disabled = !complete;
        addButton.setAttribute('aria-disabled', complete ? 'false' : 'true');
      }

      // At capacity, lock the tiles that are not part of the stack
      tiles.forEach(function (tile) {
        if (tile.disabled) return; // sold-out tiles stay as-is
        var isOn = tile.getAttribute('aria-pressed') === 'true';
        tile.classList.toggle('is-locked', complete && !isOn);
      });

      if (summary) summary.classList.toggle('is-target-reached', complete);
    }

    function resetSelection() {
      picks = [];
      tiles.forEach(function (tile) { setTileState(tile, false); });
      render();
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        if (tile.disabled) return;
        var id = tile.dataset.variantId;
        if (!id) return;
        var isOn = tile.getAttribute('aria-pressed') === 'true';
        if (isOn) {
          removePick(id);
          return;
        }
        if (picks.length >= stackSize) {
          showError(S.full);
          return;
        }
        picks.push({
          id: id,
          price: parseInt(tile.dataset.price, 10) || 0,
          compare: parseInt(tile.dataset.compare, 10) || 0,
          title: tile.dataset.title || '',
          img: tile.dataset.image || '',
        });
        setTileState(tile, true);
        showError('');
        render();
      });
    });

    function setLoading(loading) {
      if (!addButton) return;
      addButton.classList.toggle('is-loading', loading);
      addButton.setAttribute('aria-busy', loading ? 'true' : 'false');
      addButton.disabled = loading || picks.length !== stackSize;
      if (spinner) spinner.hidden = !loading;
      if (addLabel) addLabel.style.opacity = loading ? '0' : '1';
    }

    async function addStackToBag() {
      if (picks.length !== stackSize) return;

      showError('');
      setLoading(true);

      // Group the pieces as one bundle via hidden line-item properties
      // (underscore-prefixed = not shown to the customer), mirroring the
      // _type/_bundleid convention used by production BYOS implementations.
      var bundleId = 'kdn-' + Math.random().toString(36).slice(2, 10);
      var items = picks.map(function (p) {
        return {
          id: parseInt(p.id, 10),
          quantity: 1,
          properties: { _type: 'byob', _bundleid: bundleId, _item_count: stackSize },
        };
      });

      try {
        var addResponse = await postJSON('/cart/add.js', {
          items: items,
          sections: 'cart-drawer,cart-icon-bubble',
        });

        var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
        updateCartCount(cart.item_count);

        if (window.theme && window.theme.pubsub) {
          window.theme.pubsub.publish('cart:updated', {
            sections: addResponse.sections,
            opener: addButton,
          });
        }

        resetSelection();
      } catch (err) {
        var message =
          (err && (err.description || err.message)) ||
          S.error;
        showError(message);
      } finally {
        setLoading(false);
      }
    }

    if (addButton) addButton.addEventListener('click', addStackToBag);

    render();
  }

  function boot() {
    document.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init after this section's markup is swapped back in.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var target = e.target && e.target.querySelector ? e.target.querySelector('[data-bundle-builder]') : null;
      if (target) initBundleBuilder(target);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club-drop"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /** Zero-pad to 2 digits, floored at 0. @param {number} n @returns {string} */
  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  /** @param {number} n @param {number} min @param {number} max @returns {number} */
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  /**
   * Start the "next drop" countdown inside a sold-out block. Stays hidden
   * (its server-rendered default) if the target date is missing or invalid;
   * only reveals itself once it has something real to count down to.
   * @param {HTMLElement} wrap — .club-drop__countdown
   * @param {string} sectionId
   */
  function initCountdown(wrap, sectionId) {
    if (!wrap || wrap.dataset.cdReady === 'true') return;
    wrap.dataset.cdReady = 'true';

    var targetStr = wrap.dataset.target;
    var target = targetStr ? new Date(targetStr) : null;
    if (!target || isNaN(target.getTime())) return;

    var elDays = wrap.querySelector('[data-cd-days]');
    var elHours = wrap.querySelector('[data-cd-hours]');
    var elMins = wrap.querySelector('[data-cd-mins]');
    var elSecs = wrap.querySelector('[data-cd-secs]');

    function tick() {
      var remaining = target.getTime() - Date.now();

      if (remaining <= 0) {
        if (elDays) elDays.textContent = '00';
        if (elHours) elHours.textContent = '00';
        if (elMins) elMins.textContent = '00';
        if (elSecs) elSecs.textContent = '00';
        clearInterval(intervalId);
        return;
      }

      var totalSecs = Math.floor(remaining / 1000);
      if (elDays) elDays.textContent = pad(Math.floor(totalSecs / 86400));
      if (elHours) elHours.textContent = pad(Math.floor((totalSecs % 86400) / 3600));
      if (elMins) elMins.textContent = pad(Math.floor((totalSecs % 3600) / 60));
      if (elSecs) elSecs.textContent = pad(totalSecs % 60);
    }

    wrap.hidden = false;
    tick();
    var intervalId = setInterval(tick, 1000);

    document.addEventListener('shopify:section:unload', function onUnload(e) {
      if (e.detail && e.detail.sectionId === sectionId) {
        clearInterval(intervalId);
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    });
  }

  /**
   * Update the live "X of N left" counter + progress bar from fresh data.
   * Hides the whole counter when inventory isn't tracked — never shows a
   * fake number.
   * @param {HTMLElement} root
   * @param {boolean} tracked
   * @param {number} quantity
   * @param {number} dropSize
   */
  function updateCounter(root, tracked, quantity, dropSize) {
    var counter = root.querySelector('[data-club-counter]');
    if (!counter) return;

    if (!tracked) {
      counter.hidden = true;
      return;
    }

    var remaining = clamp(parseInt(quantity, 10) || 0, 0, dropSize);
    var numEl = counter.querySelector('[data-club-remaining]');
    if (numEl) numEl.textContent = String(remaining);

    var bar = root.querySelector('[data-club-progress-bar]');
    if (bar) bar.style.width = (dropSize > 0 ? (remaining * 100 / dropSize) : 0) + '%';

    counter.hidden = false;
  }

  /**
   * Swap between the claim area and the sold-out area.
   * @param {HTMLElement} root
   * @param {boolean} soldOut
   */
  function updateSoldOutState(root, soldOut) {
    var claim = root.querySelector('[data-club-claim]');
    var soldout = root.querySelector('[data-club-soldout]');
    var live = root.querySelector('[data-club-live]');
    if (claim) claim.hidden = soldOut;
    if (soldout) soldout.hidden = !soldOut;
    if (live) live.hidden = soldOut;
  }

  /**
   * One-time fetch of the product's own JSON to re-sync stock/sold-out
   * state client-side — the rendered page may be cached and the merchant's
   * inventory can move between then and now. Every failure mode (network,
   * non-OK response, bad JSON, missing variant) is swallowed silently and
   * simply leaves the server-rendered state in place.
   * @param {HTMLElement} root
   */
  function resync(root) {
    var url = root.dataset.productUrl;
    var variantId = parseInt(root.dataset.variantId, 10);
    var dropSize = parseInt(root.dataset.dropSize, 10) || 0;
    if (!url || !variantId) return;

    fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.variants) return;

        var variant = null;
        for (var i = 0; i < data.variants.length; i++) {
          if (data.variants[i].id === variantId) {
            variant = data.variants[i];
            break;
          }
        }
        if (!variant) return;

        var tracked = !!variant.inventory_management && variant.inventory_policy === 'deny';
        var soldOut = !variant.available || (tracked && variant.inventory_quantity <= 0);

        updateCounter(root, tracked, variant.inventory_quantity, dropSize);
        updateSoldOutState(root, soldOut);
      })
      .catch(function () {
        /* Offline / blocked / malformed response — keep the server-rendered state. */
      });
  }

  /** @param {HTMLElement} root — .club-drop__card[data-club-drop] */
  function initClubDrop(root) {
    if (!root || root.dataset.clubDropReady === 'true') return;
    root.dataset.clubDropReady = 'true';

    var countdown = root.querySelector('.club-drop__countdown');
    if (countdown) initCountdown(countdown, root.dataset.sectionId);

    /* The claim permalink replaces the shopper's cart (Shopify permalink
       behavior). Surface the warning note only when there is actually
       something in the cart to lose — read from the header count bubble,
       no extra request. */
    var permalinkNote = root.querySelector('[data-club-permalink-note]');
    if (permalinkNote) {
      var bubble = document.querySelector('[data-cart-count]');
      var count = bubble ? parseInt(bubble.textContent, 10) : 0;
      if (count > 0) permalinkNote.hidden = false;
    }

    resync(root);
  }

  function boot() {
    document.querySelectorAll('[data-club-drop]').forEach(initClubDrop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: (re)initialise when this section is loaded/re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-club-drop]');
    if (root) initClubDrop(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * Pad a number to 2 digits.
   * @param {number} n
   * @returns {string}
   */
  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  /**
   * Animate a digit element if the text changed.
   * Respects prefers-reduced-motion.
   * @param {HTMLElement} el
   * @param {string} newVal
   */
  function setDigit(el, newVal) {
    if (!el) return;
    if (el.textContent === newVal) return;

    el.textContent = newVal;

    var reducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;

    if (!reducedMotion) {
      el.classList.remove('kcd__number--changed');
      // Trigger reflow so animation restarts
      void el.offsetWidth;
      el.classList.add('kcd__number--changed');
    }
  }

  /**
   * Initialise one countdown timer section.
   * @param {HTMLElement} root  — the <section> element
   */
  function initCountdown(root) {
    var sectionId    = root.dataset.sectionId;
    var targetStr    = root.dataset.target;
    var endBehavior  = root.dataset.endBehavior; // 'hide' | 'message'

    // Parse target date; guard against blanks / invalid values
    var targetTime = targetStr ? new Date(targetStr) : null;
    var isValidDate = targetTime && !isNaN(targetTime.getTime());

    // DOM refs
    var elDays  = root.querySelector('#kcd-days-'  + sectionId);
    var elHours = root.querySelector('#kcd-hours-' + sectionId);
    var elMins  = root.querySelector('#kcd-mins-'  + sectionId);
    var elSecs  = root.querySelector('#kcd-secs-'  + sectionId);
    var elInner = root.querySelector('.kcd__inner');
    var elEnded = root.querySelector('#kcd-ended-' + sectionId);

    // If no valid date we leave the "--" placeholders in place (graceful)
    if (!isValidDate) return;

    function tick() {
      var now       = Date.now();
      var remaining = targetTime.getTime() - now;

      if (remaining <= 0) {
        // Timer has expired
        setDigit(elDays,  '00');
        setDigit(elHours, '00');
        setDigit(elMins,  '00');
        setDigit(elSecs,  '00');

        clearInterval(intervalId);

        if (endBehavior === 'hide') {
          // Hide the entire section
          root.setAttribute('hidden', '');
          root.style.display = 'none';
        } else {
          // Show "ended" message, hide the main content
          if (elInner) elInner.setAttribute('hidden', '');
          if (elEnded) elEnded.removeAttribute('hidden');
        }
        return;
      }

      var totalSecs = Math.floor(remaining / 1000);
      var days      = Math.floor(totalSecs / 86400);
      var hours     = Math.floor((totalSecs % 86400) / 3600);
      var mins      = Math.floor((totalSecs % 3600)  / 60);
      var secs      = totalSecs % 60;

      setDigit(elDays,  pad(days));
      setDigit(elHours, pad(hours));
      setDigit(elMins,  pad(mins));
      setDigit(elSecs,  pad(secs));
    }

    // Run immediately, then every second
    tick();
    var intervalId = setInterval(tick, 1000);

    // Clean up on section unload (theme editor support)
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.detail && e.detail.sectionId === sectionId) {
        clearInterval(intervalId);
      }
    });
  }

  /**
   * Boot: find all countdown sections on the page.
   */
  function boot() {
    document.querySelectorAll('[data-section-id][data-target][data-end-behavior]').forEach(function (el) {
      if (el.id && el.id.indexOf('CountdownTimer-') === 0) {
        initCountdown(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init when section is re-selected / reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var root = document.getElementById('CountdownTimer-' + (e.detail && e.detail.sectionId));
    if (root) initCountdown(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-tiles"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var COPIED_LABEL = 'Copied!';
  var COPIED_DURATION = 1500;

  /**
   * Copy a string to the clipboard. Prefers the async Clipboard API and
   * falls back to a hidden textarea + execCommand for older browsers or
   * insecure (non-HTTPS) contexts where navigator.clipboard is unavailable.
   * @param {string} value
   * @returns {Promise<void>}
   */
  function copyToClipboard(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value).catch(function () {
        fallbackCopy(value);
      });
    }
    fallbackCopy(value);
    return Promise.resolve();
  }

  /** @param {string} value */
  function fallbackCopy(value) {
    var textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-1000px';
    textarea.style.left = '-1000px';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    try {
      document.execCommand('copy');
    } catch (err) {
      /* Clipboard unavailable — the code text is still visible and selectable by hand. */
    }
    document.body.removeChild(textarea);
  }

  /**
   * Wire up one coupon "copy" button. Scoped entirely to `button`, so
   * multiple deal-tiles instances on the same page never interfere and
   * re-running init on an already-wired button is a safe no-op.
   * @param {HTMLElement} button
   */
  function initCouponCopy(button) {
    if (button.dataset.copyReady === 'true') return;
    button.dataset.copyReady = 'true';

    var labelEl = button.querySelector('[data-coupon-copy-label]');
    var statusEl = button.querySelector('[data-coupon-copy-status]');
    var value = button.getAttribute('data-copy-value');
    if (!value || !labelEl) return;

    var originalText = labelEl.textContent;
    var resetTimer = null;

    button.addEventListener('click', function () {
      copyToClipboard(value).then(function () {
        window.clearTimeout(resetTimer);
        labelEl.textContent = COPIED_LABEL;
        button.classList.add('dealtiles__coupon-btn--copied');
        if (statusEl) statusEl.textContent = 'Code copied to clipboard';

        resetTimer = window.setTimeout(function () {
          labelEl.textContent = originalText;
          button.classList.remove('dealtiles__coupon-btn--copied');
          if (statusEl) statusEl.textContent = '';
        }, COPIED_DURATION);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-coupon-copy-btn]').forEach(initCouponCopy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: (re)initialise when this section is loaded/re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    var buttons = e.target.querySelectorAll('[data-coupon-copy-btn]');
    buttons.forEach(initCouponCopy);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var COPIED_LABEL = 'Copied!';
  var COPIED_DURATION = 1500;

  /**
   * Copy a string to the clipboard. Prefers the async Clipboard API and
   * falls back to a hidden textarea + execCommand for older browsers or
   * insecure (non-HTTPS) contexts where navigator.clipboard is unavailable.
   * @param {string} value
   * @returns {Promise<void>}
   */
  function copyToClipboard(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value).catch(function () {
        fallbackCopy(value);
      });
    }
    fallbackCopy(value);
    return Promise.resolve();
  }

  /** @param {string} value */
  function fallbackCopy(value) {
    var textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-1000px';
    textarea.style.left = '-1000px';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    try {
      document.execCommand('copy');
    } catch (err) {
      /* Clipboard unavailable — the code text is still visible and selectable by hand. */
    }
    document.body.removeChild(textarea);
  }

  /**
   * Wire up one promo-code "copy" chip. Scoped entirely to `button`, so
   * multiple offer-strip instances on the same page never interfere.
   * @param {HTMLElement} button
   */
  function initCopyButton(button) {
    var labelEl = button.querySelector('[data-copy-label]');
    var statusEl = button.querySelector('[data-offer-copy-status]');
    var value = button.getAttribute('data-copy-value');
    if (!value || !labelEl) return;

    var originalText = labelEl.textContent;
    var resetTimer = null;

    button.addEventListener('click', function () {
      copyToClipboard(value).then(function () {
        window.clearTimeout(resetTimer);
        labelEl.textContent = COPIED_LABEL;
        button.classList.add('offer-strip__code--copied');
        if (statusEl) statusEl.textContent = 'Code copied to clipboard';

        resetTimer = window.setTimeout(function () {
          labelEl.textContent = originalText;
          button.classList.remove('offer-strip__code--copied');
          if (statusEl) statusEl.textContent = '';
        }, COPIED_DURATION);
      });
    });
  }

  /**
   * Wire up the dismiss (×) control: hides the strip and remembers the
   * choice in localStorage under a key derived from this offer's content,
   * so editing the message/code later reveals the strip again for everyone.
   * @param {HTMLElement} root
   */
  function initDismiss(root) {
    var storageKey = root.getAttribute('data-storage-key');
    var dismissBtn = root.querySelector('[data-offer-dismiss]');

    if (storageKey) {
      var alreadyDismissed = false;
      try {
        alreadyDismissed = window.localStorage.getItem(storageKey) === 'dismissed';
      } catch (err) {
        /* localStorage unavailable (private mode, disabled, etc.) — always show. */
      }
      if (alreadyDismissed) {
        root.hidden = true;
        return;
      }
    }

    if (!dismissBtn) return;

    dismissBtn.addEventListener('click', function () {
      root.hidden = true;
      if (storageKey) {
        try {
          window.localStorage.setItem(storageKey, 'dismissed');
        } catch (err) {
          /* Ignore write failures — dismissal just won't persist across visits. */
        }
      }
    });
  }

  /**
   * Initialise one offer-strip instance. Safe to call more than once and
   * safe with any number of instances on the page — every lookup below is
   * scoped to `root`.
   * @param {HTMLElement} root
   */
  function initOfferStrip(root) {
    if (root.dataset.offerStripReady === 'true') return;
    root.dataset.offerStripReady = 'true';

    initDismiss(root);
    if (root.hidden) return; // dismissed on load — nothing else to wire up

    var copyButtons = root.querySelectorAll('[data-offer-copy]');
    for (var i = 0; i < copyButtons.length; i++) {
      initCopyButton(copyButtons[i]);
    }
  }

  function boot() {
    document.querySelectorAll('[data-offer-strip]').forEach(initOfferStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: (re)initialise when this section is loaded/re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-offer-strip]');
    if (root) initOfferStrip(root);
  });

  /* Theme editor: always reveal the strip while a merchant is editing it,
     even if this browser had previously dismissed it as a shopper. */
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-offer-strip]');
    if (root) root.hidden = false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * Minimal ₹ formatter — Shopify prices are integers in the smallest
   * currency unit (paise), so divide by 100 and group with Indian digit
   * spacing (1,00,000 style) via toLocaleString.
   */
  function formatMoney(cents) {
    var amount = Math.round((cents || 0) / 100);
    var grouped = Math.abs(amount).toLocaleString('en-IN');
    return (amount < 0 ? '-' : '') + '₹' + grouped;
  }

  async function postJSON(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) throw data;
    return data;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function initStack(root) {
    if (!root || root.dataset.stackReady === 'true') return;
    root.dataset.stackReady = 'true';

    var pieces = Array.prototype.slice.call(root.querySelectorAll('[data-stack-piece]'));
    var totalEl = root.querySelector('[data-stack-total]');
    var addButton = root.querySelector('[data-stack-add]');
    var errorEl = root.querySelector('[data-stack-error]');
    var spinner = addButton ? addButton.querySelector('[data-stack-spinner]') : null;

    // Shopper-facing copy — read once from the section's data attributes
    // (themselves rendered from section settings), falling back to the
    // original literals if a setting is ever missing.
    var S = {
      unavailable: root.dataset.strUnavailable || 'This stack is currently unavailable.',
      error: root.dataset.strError || 'Something went wrong adding this stack — please try again.',
    };

    // Recompute the running total client-side from each piece's data-price,
    // formatted the same way as the rest of the storefront.
    var total = pieces.reduce(function (sum, piece) {
      return sum + (parseInt(piece.dataset.price, 10) || 0);
    }, 0);
    if (totalEl) totalEl.textContent = formatMoney(total);

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function setLoading(loading) {
      if (!addButton) return;
      addButton.classList.toggle('is-loading', loading);
      addButton.setAttribute('aria-busy', loading ? 'true' : 'false');
      addButton.disabled = loading;
      if (spinner) spinner.hidden = !loading;
    }

    async function addStackToCart() {
      var items = pieces
        .filter(function (piece) { return !!piece.dataset.variantId; })
        .map(function (piece) {
          return { id: parseInt(piece.dataset.variantId, 10), quantity: 1 };
        });

      if (!items.length) {
        showError(S.unavailable);
        return;
      }

      showError('');
      setLoading(true);

      try {
        var addResponse = await postJSON('/cart/add.js', {
          items: items,
          sections: 'cart-drawer,cart-icon-bubble',
        });

        var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
        updateCartCount(cart.item_count);

        if (window.theme && window.theme.pubsub) {
          window.theme.pubsub.publish('cart:updated', {
            sections: addResponse.sections,
            opener: addButton,
          });
        }
      } catch (err) {
        var message =
          (err && (err.description || err.message)) ||
          S.error;
        showError(message);
      } finally {
        setLoading(false);
      }
    }

    if (addButton) addButton.addEventListener('click', addStackToCart);
  }

  function boot() {
    document.querySelectorAll('[data-stack]').forEach(initStack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init after this section's markup is swapped back in.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var target = e.target && e.target.querySelector ? e.target.querySelector('[data-stack]') : null;
      if (target) initStack(target);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * Scoped tab controller — runs once per section instance.
   * Uses data-tp-* attributes to avoid global class collisions.
   */
  function initTabbedProducts(section) {
    var tablist = section.querySelector('[data-tp-tablist]');
    if (!tablist) return;

    var tabs   = Array.from(section.querySelectorAll('[data-tp-tab]'));
    var panels = Array.from(section.querySelectorAll('[data-tp-panel]'));

    if (!tabs.length) return;

    /** Activate one tab/panel by index */
    function activateTab(index) {
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var active = i === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    /** Click handler */
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activateTab(i);
        tab.focus();
      });
    });

    /** Keyboard: arrow keys for roving tabindex */
    tablist.addEventListener('keydown', function (e) {
      var currentIndex = tabs.findIndex(function (t) {
        return t === document.activeElement;
      });
      if (currentIndex === -1) return;

      var nextIndex = currentIndex;

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (e.key === 'Home') {
        e.preventDefault();
        nextIndex = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      activateTab(nextIndex);
      tabs[nextIndex].focus();
    });
  }

  /** Boot on DOMContentLoaded or immediately if already loaded */
  function boot() {
    document.querySelectorAll('[data-tp-tablist]').forEach(function (tablist) {
      var section = tablist.closest('[id^="tabbed-products-"]');
      if (section) initTabbedProducts(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /**
   * Shopify theme editor: re-init when blocks are added/removed/reordered.
   * section:load fires when the section is re-rendered in the editor.
   */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target;
      if (section && section.id && section.id.indexOf('tabbed-products-') === 0) {
        initTabbedProducts(section);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
